import form from "./form";

const {
  formField: { hours, is_free, is_late_night, players },
} = form;

const initialValues = {
  [hours.name]: 1, // Defaults to 1 hour
  [is_free.name]: false, // Default: Not free
  [is_late_night.name]: false, // Default: Not late night
  [players.name]: [], // No players selected initially
};

export default initialValues;
